import React from 'react';
import Loadable from 'react-loadable';
import { RouteComponentProps } from 'react-router';

import BlankLoadingPage from '../../../shared/components/BlankLoadingPage';
import { getQueryFromLocation } from '../../../shared/utils/urls';
import { LoadableWidgetReschedulePage } from '../../index';

const LoadableSchedulingReschedulePage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "schedulingReschedulePage" */ './SchedulingReschedulePage'),
  loading: () => <BlankLoadingPage />,
});

type Params = { id: string };

export default function SchedulingReschedulePage(props: RouteComponentProps<Params>) {
  const { exp_widget_v2 } = getQueryFromLocation(props.location);

  if (exp_widget_v2 == null || exp_widget_v2 === '') {
    return <LoadableWidgetReschedulePage {...props} />;
  }
  return <LoadableSchedulingReschedulePage {...props} />;
}
